












































































































































































































































































































































































import { Component, Watch, Prop, Vue } from 'vue-property-decorator'
/* component */
import MachineRentTab from '@/app/components/MachineRent/MachineRentTab.vue'
import Datepicker from 'vuejs-datepicker'
import { ja } from 'vuejs-datepicker/dist/locale'
/* api */
import GroupListApi from '@/app/model/api/groupListApi'
import MachineListApi from '@/app/model/api/machineListApi'
import AccountListApi from '@/app/model/api/accountListApi'
/* module */
import Local from '@/app/module/local'
import CommonClass from '@/app/module/common'

@Component({
  components: {
    MachineRentTab,
    Datepicker
  }
})
export default class MachineRentSearch extends Vue {
  private constantValue: any
  private search: string = this.$store.state.machineRentState.searchText
  private step: number|null = this.$store.state.machineRentState.step
  private rentStatus: number|null = this.$store.state.machineRentState.rentStatus
  private groupId: number|null = this.$store.state.machineRentState.groupId
  private machineId: number|null = this.$store.state.machineRentState.machineId
  private machineType: number|null = this.$store.state.machineRentState.machineType
  private createdAt: number|null = this.$store.state.machineRentState.createdAt
  private createdBy: number|null = this.$store.state.machineRentState.createdBy
  private createdType: number|null = this.$store.state.machineRentState.createdType
  private rentStartDate: number|null = this.$store.state.machineRentState.rentStartDate
  private rentEndDate: number|null = this.$store.state.machineRentState.rentEndDate
  private useStartDate: number|null = this.$store.state.machineRentState.useStartDate
  private useEndDate: number|null = this.$store.state.machineRentState.useEndDate
  private limit: number|null = this.$store.state.machineRentState.limit
  private accountId: string = this.$store.state.machineRentState.accountId
  private stasusSelected: any = [
    { text: 'すべて', value: null },
    { text: '未完了のみ', value: 1 },
    { text: '遅延', value: 2 },
    { text: '却下/キャンセル/中止', value: 3 }
  ]
  private groupData: any = {}
  private machineData: any = {}
  private displayMachineData: any = {}
  private accountData: any = {}
  /* datepicker */
  private japanese: any = ja
  private form: any = 'yyyy-MM-dd'

  @Prop() private count!: number

  created () {
    this.constantValue = JSON.parse(Local.getConstantValue()!)
    this.getGroupList()
    this.getMachineList()
    this.getAccountList()
  }

  private getGroupList () {
    (async () => {
      const data: any = {
        order_name: 'group_name',
        sort: 'asc',
        text: ''
      }

      const result = await GroupListApi.getGroupList(data)
      if (result.isOk()) {
        this.groupData = result.getPayload().groups
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
    })()
  }

  private getMachineList () {
    (async () => {
      const data = {
        word: '',
        order_name: 'machine_name',
        sort: true,
        is_valid: null,
        machine_type: null
      }

      const result = await MachineListApi.getMachineList(data)

      if (result.isOk()) {
        this.machineData = result.getPayload().results
        this.changeMachineType()
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
    })()
  }

  // 生産者情報取得
  private getAccountList () {
    (async () => {
      const data = {
        type: 0,
        text: '',
        order_name: 'name',
        sort: 'asc'
      }

      const result = await AccountListApi.getAccountList(data)

      if (result.isOk()) {
        this.accountData = result.getPayload().users
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
    })()
  }

  private changeMachineType () {
    if (this.machineType === null) {
      this.displayMachineData = this.machineData
    } else {
      this.displayMachineData = this.machineData.filter((data: any) => data.machine_type === this.machineType)
      // 選択中のmachineIdがあるかチェック
      let machinIdData = this.displayMachineData.filter((data: any) => data.machine_id === this.machineId)
      if (machinIdData.length === 0) {
        this.machineId = null
      }
    }
  }

  private doSearch () {
    // 検索保持
    this.$store.commit('machineRentState/setSearchText', this.search)
    this.$store.commit('machineRentState/setStep', this.step)
    this.$store.commit('machineRentState/setRentStatus', this.rentStatus)
    this.$store.commit('machineRentState/setGroupId', this.groupId)
    this.$store.commit('machineRentState/setMachineId', this.machineId)
    this.$store.commit('machineRentState/setMachineType', this.machineType)
    this.$store.commit('machineRentState/setCreatedAt', this.createdAt)
    this.$store.commit('machineRentState/setCreatedBy', this.createdBy)
    this.$store.commit('machineRentState/setCreatedType', this.createdType)
    this.$store.commit('machineRentState/setRentStartDate', this.rentStartDate)
    this.$store.commit('machineRentState/setRentEndDate', this.rentEndDate)
    this.$store.commit('machineRentState/setUseStartDate', this.useStartDate)
    this.$store.commit('machineRentState/setUseEndDate', this.useEndDate)
    this.$store.commit('machineRentState/setLimit', this.limit)
    this.$store.commit('machineRentState/setAccountId', this.accountId)
    this.$emit('search-list')
  }

  private doClear () {
    // 検索をリセット
    this.search = ''
    this.step = null
    this.rentStatus = 1
    this.groupId = null
    this.machineId = null
    this.machineType = null
    this.createdAt = null
    this.createdBy = null
    this.createdType = null
    this.rentStartDate = null
    this.rentEndDate = null
    this.useStartDate = null
    this.useEndDate = null
    this.limit = null
    this.accountId = ''
    this.changeMachineType()
    // 保持をリセット
    this.$store.commit('machineRentState/setSearchText', '')
    this.$store.commit('machineRentState/setStep', null)
    this.$store.commit('machineRentState/setRentStatus', 1)
    this.$store.commit('machineRentState/setGroupId', null)
    this.$store.commit('machineRentState/setMachineId', null)
    this.$store.commit('machineRentState/setMachineType', null)
    this.$store.commit('machineRentState/setCreatedAt', null)
    this.$store.commit('machineRentState/setCreatedBy', null)
    this.$store.commit('machineRentState/setCreatedType', null)
    this.$store.commit('machineRentState/setRentStartDate', null)
    this.$store.commit('machineRentState/setRentEndDate', null)
    this.$store.commit('machineRentState/setUseStartDate', null)
    this.$store.commit('machineRentState/setUseEndDate', null)
    this.$store.commit('machineRentState/setLimit', null)
    this.$store.commit('machineRentState/setAccountId', null)
    this.$emit('reset-list')
  }

  private changeStep (step: number) {
    if (step === 7) {
      this.rentStatus = null
    }
  }
}
